import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../config';

const S = {
  page:    { minHeight:'100vh', background:'#0f172a', fontFamily:'sans-serif', direction:'rtl', padding:'24px' },
  back:    { background:'none', border:'1px solid #334155', color:'#94a3b8', padding:'8px 16px', borderRadius:'8px', cursor:'pointer', fontSize:'13px', marginBottom:'20px' },
  title:   { color:'#f1f5f9', fontSize:'22px', fontWeight:'900', margin:'0 0 4px' },
  sub:     { color:'#64748b', fontSize:'14px', margin:'0 0 24px' },
  grid:    { display:'grid', gridTemplateColumns:'1fr 1fr', gap:'16px', marginBottom:'20px' },
  card:    { background:'#1e293b', borderRadius:'12px', padding:'20px', border:'1px solid #334155' },
  cardTitle:{ color:'#94a3b8', fontSize:'12px', fontWeight:'bold', marginBottom:'12px', textTransform:'uppercase' },
  row:     { display:'flex', justifyContent:'space-between', padding:'8px 0', borderBottom:'1px solid #334155', fontSize:'13px' },
  rowLabel:{ color:'#64748b' },
  rowVal:  { color:'#f1f5f9', fontWeight:'bold' },
  badge:   (c) => ({ padding:'3px 10px', borderRadius:'20px', fontSize:'12px', fontWeight:'bold', background:c+'22', color:c }),
  actionBar: { display:'flex', gap:'10px', marginBottom:'20px', flexWrap:'wrap' },
  approveBtn:{ padding:'10px 20px', background:'#14532d', border:'1px solid #166534', borderRadius:'8px', color:'#86efac', fontSize:'13px', cursor:'pointer', fontWeight:'bold' },
  rejectBtn: { padding:'10px 20px', background:'#450a0a', border:'1px solid #7f1d1d', borderRadius:'8px', color:'#fca5a5', fontSize:'13px', cursor:'pointer', fontWeight:'bold' },
  payBtn:    { padding:'10px 20px', background:'#1e3a5f', border:'1px solid #1d4ed8', borderRadius:'8px', color:'#93c5fd', fontSize:'13px', cursor:'pointer', fontWeight:'bold' },
  modal:   { position:'fixed', inset:0, background:'rgba(0,0,0,0.7)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:9999, padding:'20px' },
  modalBox:{ background:'#1e293b', borderRadius:'16px', padding:'24px', width:'100%', maxWidth:'440px', border:'1px solid #334155' },
  modalTitle:{ color:'#f1f5f9', fontSize:'16px', fontWeight:'bold', margin:'0 0 16px' },
  input:   { width:'100%', padding:'10px', background:'#0f172a', border:'1px solid #334155', borderRadius:'8px', color:'#f1f5f9', fontSize:'14px', boxSizing:'border-box', outline:'none', marginBottom:'12px' },
  submitBtn:{ width:'100%', padding:'12px', background:'#1d4ed8', border:'none', borderRadius:'8px', color:'#fff', fontSize:'14px', fontWeight:'bold', cursor:'pointer' },
  errBox:  { background:'#450a0a', border:'1px solid #7f1d1d', borderRadius:'8px', padding:'10px', color:'#fca5a5', fontSize:'13px', marginBottom:'12px' },
  sucBox:  { background:'#052e16', border:'1px solid #166534', borderRadius:'8px', padding:'10px', color:'#86efac', fontSize:'13px', marginBottom:'12px' },
  table:   { width:'100%', borderCollapse:'collapse' },
  th:      { padding:'10px 14px', textAlign:'right', fontSize:'12px', color:'#64748b', borderBottom:'1px solid #334155', background:'#0f172a' },
  td:      { padding:'10px 14px', fontSize:'13px', color:'#e2e8f0', borderBottom:'1px solid #1e293b' },
};

const STATUS_COLOR = { approved:'#22c55e', payment_pending:'#3b82f6', pending:'#f59e0b', rejected:'#ef4444', suspended:'#94a3b8', online:'#22c55e', offline:'#94a3b8', busy:'#f59e0b' };
const STATUS_AR = { approved:'معتمد', payment_pending:'في انتظار الدفع', pending:'قيد المراجعة', rejected:'مرفوض', suspended:'موقوف', online:'متاح', offline:'غير متاح', busy:'مشغول' };

export default function CompanyDetails({ companyId, onBack }) {
  const [company, setCompany] = useState(null);
  const [drivers, setDrivers] = useState([]);
  const [modal,   setModal]   = useState(null);
  const [form,    setForm]    = useState({});
  const [err,     setErr]     = useState('');
  const [suc,     setSuc]     = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    axios.get(`${API}/companies/${companyId}`).then(r => setCompany(r.data.company));
    axios.get(`${API}/drivers?company_id=${companyId}`).then(r => setDrivers(r.data.drivers));
  }, [companyId]);

  const openModal = (type, data={}) => { setModal(type); setForm(data); setErr(''); setSuc(''); };
  const closeModal = () => { setModal(null); setErr(''); setSuc(''); };

  const submit = async () => {
    setErr(''); setSuc(''); setLoading(true);
    try {
      if (modal === 'approve') {
        await axios.patch(`${API}/companies/${companyId}/status`, {
          status: 'approved',
          platform_fee_pct: parseFloat(form.platform_fee_pct || 15),
          subscription_fee: parseFloat(form.subscription_fee || 500),
        });
        setSuc('✅ تمت الموافقة وتم إرسال إيميل رابط الدفع');
        axios.get(`${API}/companies/${companyId}`).then(r => setCompany(r.data.company));
      } else if (modal === 'reject') {
        await axios.patch(`${API}/companies/${companyId}/status`, {
          status: 'rejected',
          rejection_reason: form.rejection_reason || 'غير مستوفٍ للشروط',
        });
        setSuc('تم الرفض');
        axios.get(`${API}/companies/${companyId}`).then(r => setCompany(r.data.company));
      } else if (modal === 'confirm_payment') {
        const credRes = await axios.patch(`${API}/companies/${companyId}/subscription`);
      if(credRes.data.credentials){
        const c = credRes.data.credentials;
        setSuc('تم التفعيل! | الهاتف: ' + c.phone + ' | الباسورد: ' + c.password + ' | الرابط: ' + c.url);
      }
        setSuc('✅ تم تأكيد الدفع وإرسال بيانات الدخول على الإيميل');
        axios.get(`${API}/companies/${companyId}`).then(r => setCompany(r.data.company));
      } else if (modal === 'approve_driver') {
        await axios.patch(`${API}/drivers/${form.id}/status`, { status: 'approved' });
        setSuc('تم اعتماد الطيار');
        axios.get(`${API}/drivers?company_id=${companyId}`).then(r => setDrivers(r.data.drivers));
      } else if (modal === 'reject_driver') {
        await axios.patch(`${API}/drivers/${form.id}/status`, { status: 'rejected', rejection_reason: form.rejection_reason || 'غير مستوفٍ للشروط' });
        setSuc('تم رفض الطيار');
        axios.get(`${API}/drivers?company_id=${companyId}`).then(r => setDrivers(r.data.drivers));
      }
    } catch(e) { setErr(e.response?.data?.error || 'حصل خطأ'); }
    finally { setLoading(false); }
  };

  if (!company) return <div style={{color:'#fff', padding:'40px', textAlign:'center'}}>⏳ جاري التحميل...</div>;

  const handleDelete = async () => {
    if (window.confirm(`هل أنت متأكد من حذف شركة ${company?.name} نهائياً؟ لا يمكن التراجع!`)) {
      await axios.delete(`${API}/admin/companies/${companyId}`);
      onBack();
    }
  };

  return (
    <div style={S.page}>
      <button style={S.back} onClick={onBack}>← رجوع للشركات</button>

      <h1 style={S.title}>{company.name}</h1>
      <p style={S.sub}>تفاصيل الشركة وإدارتها</p>

      <div style={S.actionBar}>
        {company.status === 'pending' && <>
          <button style={S.approveBtn} onClick={() => openModal('approve', { platform_fee_pct: 15, subscription_fee: 500 })}>✅ موافقة وإرسال رابط الدفع</button>
          <button style={S.rejectBtn} onClick={() => openModal('reject')}>❌ رفض</button>
        </>}
        {company.status === 'approved' && !company.subscription_paid && (
          <button style={S.payBtn} onClick={() => openModal('confirm_payment')}>💵 تأكيد استلام الدفع يدوياً</button>
        )}
        {company.status === 'approved' && (
          <button style={S.rejectBtn} onClick={() => openModal('reject')}>⏸ إيقاف الشركة</button>
        )}
      </div>

      <div style={S.grid}>
        <div style={S.card}>
          <div style={S.cardTitle}>بيانات الشركة</div>
          {[['الاسم', company.name], ['الإيميل', company.email], ['الهاتف', company.phone], ['العنوان', company.address || '—'], ['السجل التجاري', company.national_id || '—'], ['تاريخ التسجيل', new Date(company.created_at).toLocaleDateString('ar-EG')]].map(([l, v]) => (
            <div key={l} style={S.row}><span style={S.rowLabel}>{l}</span><span style={S.rowVal}>{v}</span></div>
          ))}
        </div>
        <div style={S.card}>
          <div style={S.cardTitle}>الحالة المالية</div>
          {[
            ['الحالة', <span style={S.badge(STATUS_COLOR[company.status] || '#94a3b8')}>{STATUS_AR[company.status] || company.status}</span>],
            ['نسبة المنصة', company.platform_fee_pct + '%'],
            ['رسوم الاشتراك', (company.subscription_fee || 500) + ' جنيه'],
            ['الاشتراك', company.subscription_paid ? <span style={{color:'#22c55e'}}>✅ مدفوع</span> : <span style={{color:'#ef4444'}}>❌ لم يُدفع</span>],
            ['طيارين نشطين', company.active_drivers || 0],
            ['إجمالي الطيارين', company.total_drivers || 0],
          ].map(([l, v]) => (
            <div key={l} style={S.row}><span style={S.rowLabel}>{l}</span><span style={S.rowVal}>{v}</span></div>
          ))}
        </div>
      </div>

      
      {company.documents && (company.documents.commercial_register || company.documents.tax_card) && (
        <div style={S.card}>
          <div style={S.cardTitle}>📄 المستندات المرفوعة</div>
          {company.documents.commercial_register && (
            <div style={{padding:'16px', borderBottom:'1px solid #334155'}}>
              <p style={{color:'#94a3b8', fontSize:'13px', margin:'0 0 10px'}}>السجل التجاري:</p>
              <div style={{display:'flex', gap:'10px', flexWrap:'wrap'}}>
                {company.documents.commercial_register.map((url,i) => (
                  <a key={i} href={'https://besor3a.com'+url} target="_blank" rel="noreferrer"
                    style={{padding:'8px 14px', background:'#1e3a5f', border:'1px solid #1d4ed8', borderRadius:'8px', color:'#93c5fd', fontSize:'13px', textDecoration:'none'}}>
                    🖼️ صورة {i+1}
                  </a>
                ))}
              </div>
            </div>
          )}
          {company.documents.tax_card && (
            <div style={{padding:'16px'}}>
              <p style={{color:'#94a3b8', fontSize:'13px', margin:'0 0 10px'}}>البطاقة الضريبية:</p>
              <div style={{display:'flex', gap:'10px', flexWrap:'wrap'}}>
                {company.documents.tax_card.map((url,i) => (
                  <a key={i} href={'https://besor3a.com'+url} target="_blank" rel="noreferrer"
                    style={{padding:'8px 14px', background:'#1e3a5f', border:'1px solid #1d4ed8', borderRadius:'8px', color:'#93c5fd', fontSize:'13px', textDecoration:'none'}}>
                    🖼️ صورة {i+1}
                  </a>
                ))}
              </div>
            </div>
          )}
        </div>
      )}

      <div style={S.card}>
        <div style={S.cardTitle}>الطيارين ({drivers.length})</div>
        {drivers.length === 0 ? (
          <div style={{textAlign:'center', padding:'20px', color:'#64748b'}}>لا يوجد طيارين مسجلين</div>
        ) : (
          <table style={S.table}>
            <thead><tr>{['الاسم','الهاتف','المركبة','اللوحة','الحالة','التوفر','الرحلات','إجراءات'].map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
            <tbody>
              {drivers.map(d => (
                <tr key={d.id}>
                  <td style={S.td}>{d.full_name}</td>
                  <td style={S.td}>{d.phone}</td>
                  <td style={S.td}>{d.vehicle_type || '—'}</td>
                  <td style={S.td}>{d.vehicle_plate || '—'}</td>
                  <td style={S.td}><span style={S.badge(STATUS_COLOR[d.status] || '#94a3b8')}>{STATUS_AR[d.status] || d.status}</span></td>
                  <td style={S.td}><span style={S.badge(STATUS_COLOR[d.availability] || '#94a3b8')}>{STATUS_AR[d.availability] || d.availability}</span></td>
                  <td style={S.td}>{d.total_trips}</td>
                  <td style={S.td}>
                    {d.status === 'pending' && <>
                      <button style={{...S.approveBtn, padding:'4px 10px', fontSize:'11px'}} onClick={() => openModal('approve_driver', { id: d.id, name: d.full_name })}>✅</button>
                      <button style={{...S.rejectBtn, padding:'4px 10px', fontSize:'11px', marginRight:'4px'}} onClick={() => openModal('reject_driver', { id: d.id, name: d.full_name })}>❌</button>
                    </>}
                    {d.status === 'approved' && <button style={{...S.rejectBtn, padding:'4px 10px', fontSize:'11px'}} onClick={() => openModal('reject_driver', { id: d.id, name: d.full_name })}>⏸</button>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {modal && (
        <div style={S.modal} onClick={e => e.target === e.currentTarget && closeModal()}>
          <div style={S.modalBox}>
            <h3 style={S.modalTitle}>
              {modal==='approve' && '✅ موافقة على الشركة'}
              {modal==='reject' && '❌ رفض / إيقاف الشركة'}
              {modal==='confirm_payment' && '💵 تأكيد استلام الدفع'}
              {modal==='approve_driver' && `✅ موافقة على: ${form.name}`}
              {modal==='reject_driver' && `❌ رفض: ${form.name}`}
            </h3>
            {err && <div style={S.errBox}>{err}</div>}
            {suc && <div style={S.sucBox}>{suc}</div>}
            {modal === 'approve' && <>
              <input style={S.input} type="number" placeholder="نسبة المنصة %" value={form.platform_fee_pct || 15} onChange={e => setForm({...form, platform_fee_pct: e.target.value})}/>
              <input style={S.input} type="number" placeholder="رسوم الاشتراك جنيه" value={form.subscription_fee || 500} onChange={e => setForm({...form, subscription_fee: e.target.value})}/>
              <p style={{color:'#64748b', fontSize:'12px', margin:'0 0 12px'}}>سيتم إرسال إيميل برابط الدفع تلقائياً</p>
            </>}
            {modal === 'confirm_payment' && <p style={{color:'#94a3b8', fontSize:'14px', margin:'0 0 16px'}}>سيتم تفعيل الحساب وإرسال بيانات الدخول على إيميل الشركة تلقائياً</p>}
            {(modal === 'reject' || modal === 'reject_driver') && <input style={S.input} placeholder="سبب الرفض" value={form.rejection_reason || ''} onChange={e => setForm({...form, rejection_reason: e.target.value})}/>}
            {!suc && <button style={S.submitBtn} onClick={submit} disabled={loading}>{loading ? '⏳ جاري...' : 'تأكيد'}</button>}
          </div>
        </div>
      )}
    </div>
  );
}
// patch
